import cn from "classnames"
import { useAtom } from "jotai"

import { productPagePropsAtom } from "pages/products/[slug]"
import { formatAmountForDisplay } from "utils/stripe"

import { priceAtom } from "."

const TotalsTable: React.FC<JSX.IntrinsicElements["table"]> = ({ ...rest }) => {
  const wrapperClass = cn({
    [rest?.className as string]: !!rest?.className
  })
  rest = { ...rest, className: wrapperClass }

  const [productPageProps] = useAtom(productPagePropsAtom)
  const [price] = useAtom(priceAtom)

  const calculatedPrice = price.variant + price.addons
  const VAT = (price.variant + price.addons) * 0.2
  const priceWithVAT =
    (price.variant + price.addons) * (productPageProps?.isVATEnabled ? 1.2 : 1)
  const deposit =
    (price.variant + price.addons) *
    (productPageProps?.isVATEnabled ? 1.2 : 1) *
    ((productPageProps?.depositPercentage || 0) / 100)

  return (
    <>
      <table {...rest}>
        <tbody>
          <tr>
            <td className="font-bold">Price</td>
            <td>{formatAmountForDisplay(calculatedPrice, "gbp")}</td>
          </tr>
          {productPageProps?.isVATEnabled && (
            <tr>
              <td className="font-bold">VAT</td>
              <td>{formatAmountForDisplay(VAT, "gbp")}</td>
            </tr>
          )}
          <tr>
            <td className="font-bold">Total</td>
            <td>{formatAmountForDisplay(priceWithVAT, "gbp")}</td>
          </tr>
          {/* Use depositPercentage to calculate a % of the total to charge as a deposit */}
          {productPageProps?.isDepositsEnabled && (
            <tr>
              <td className="font-bold">Deposit:</td>
              <td>{formatAmountForDisplay(deposit, "gbp")}</td>
            </tr>
          )}
        </tbody>
      </table>
      {productPageProps?.isDepositsEnabled && (
        <p className="text-sm">
          A deposit of {productPageProps.depositPercentage}% is due today &amp;
          we will take the remaining balance on the day of installation.
        </p>
      )}
    </>
  )
}

export default TotalsTable
